import { ReactElement } from "react"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"
import { IGroupForm, IQuestionForm } from "interfaces/xlsForm"
import useCommon from "hooks/useCommon"
import {
  useGetXlsFormFieldsWithGroupsQuery,
  useSaveGroupMutation,
  useSaveQuestionMutation,
} from "services/household/xlsFormSchemas"
import FormList from "components/Household/Form/FormList"

interface Props {
  xlsFormId: number
  permissions: boolean
}

const XlsFormList = ({ xlsFormId, permissions }: Props): ReactElement => {
  const { showSnackBar } = useCommon()

  const { data: formList } = useGetXlsFormFieldsWithGroupsQuery({ xlsFormId }, { skip: !xlsFormId })
  const [saveQuestion, { isLoading: loadingSaveQuestion }] = useSaveQuestionMutation()
  const [saveGroup, { isLoading: loadingSaveGroup }] = useSaveGroupMutation()

  const onQuestionSave = async (payload: IQuestionForm, onClose: () => void): Promise<void> => {
    try {
      await saveQuestion({ xlsFormId, ...payload }).unwrap()
      showSnackBar("Question saved successfully")
      onClose()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar((error?.data as { message: string })?.message ?? "Question save failed", "error")
    }
  }

  const onGroupSave = async (payload: IGroupForm, onClose: () => void): Promise<void> => {
    try {
      await saveGroup({ xlsFormId, ...payload }).unwrap()
      showSnackBar("Group saved successfully")
      onClose()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar((error?.data as { message: string })?.message ?? "Group save failed", "error")
    }
  }

  return (
    <FormList
      xlsFormId={xlsFormId}
      permissions={permissions}
      saveQuestion={onQuestionSave}
      saveGroup={onGroupSave}
      loadingSaveQuestion={loadingSaveQuestion}
      loadingSaveGroup={loadingSaveGroup}
      list={formList ?? []}
    />
  )
}

export default XlsFormList
